import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  accept_assessment_kit_action,
  get_assigned_assessment_kit_details_data_action,
  get_candidate_profile_data_action,
  decline_assessment_kit_action,
} from "../../../redux/_actions";
import { appRoutes } from "../../../_routes/app-routes";

function useAssignedAssessmentDetail() {
  const params = useParams();
  const navigate = useNavigate();

  const [assignedAssessmentData, setAssignedAssessmentData] = useState({});
  const [loading, setLoading] = useState(false);
  const [acceptLoading, setAcceptLoading] = useState(false);
  const [declineLoading, setDeclineLoading] = useState(false);
  const [isDeclineModal, setIsDeclineModal] = useState(false);
  const [user, setUser] = useState();

  const dispatch = useDispatch();

  const { candidateAssignedAssessmentData } = useSelector(
    (state) => state.get_assigned_assessment_kit_details_data_reducer
  );

  const { userProfileData } = useSelector(
    (state) => state.get_candidate_profile_data_reducer
  );

  useEffect(() => {
    let id = params?.assessmentId;
    if (id) {
      callApi(id);
    }
  }, []);

  useEffect(() => {
    if (candidateAssignedAssessmentData) {
      setAssignedAssessmentData(candidateAssignedAssessmentData);
    }
  }, [candidateAssignedAssessmentData]);

  useEffect(() => {
    if (userProfileData?.data) {
      setUser(userProfileData?.data);
    }
  }, [userProfileData]);

  const callApi = async (id) => {
    setLoading(true);
    if (id) {
      await dispatch(get_assigned_assessment_kit_details_data_action(id));
      await dispatch(get_candidate_profile_data_action());
    }
    setLoading(false);
  };

  const onAcceptAssessmentClick = async (id) => {
    setAcceptLoading(true);
    const res = await dispatch(accept_assessment_kit_action(id));
    if (res?.id) {
      await dispatch(get_assigned_assessment_kit_details_data_action(res?.id));
    }
    setAcceptLoading(false);
  };

  const onDeclineAssessmentClick = async () => {
    const id = assignedAssessmentData?.id;
    setDeclineLoading(true);
    const res = await dispatch(decline_assessment_kit_action(id));
    if (res?.id) {
      await dispatch(get_assigned_assessment_kit_details_data_action(res?.id));
      handleIsDeclineModal();
    }

    setDeclineLoading(false);
  };

  const handleIsDeclineModal = () => {
    setIsDeclineModal(!isDeclineModal);
  };

  const onStartAssessmentClick = async (id) => {
    navigate(
      appRoutes.assessementKit.previewAssessment.replace(
        ":assignedAssessmentId",
        assignedAssessmentData?.id
      )
    );
  };

  return {
    loading,
    acceptLoading,
    declineLoading,
    isDeclineModal,
    assignedAssessmentData,
    user,
    onAcceptAssessmentClick,
    handleIsDeclineModal,
    onStartAssessmentClick,
    onDeclineAssessmentClick,
  };
}

export default useAssignedAssessmentDetail;
